'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @fileoverview 浏览器相关
 * @author kirkzheng
 */

var userAgent = (typeof navigator === 'undefined' ? 'undefined' : _typeof(navigator)) === 'object' && navigator.userAgent.toLowerCase();

var getOSName = exports.getOSName = function getOSName() {
    var userAgent = (typeof navigator === 'undefined' ? 'undefined' : _typeof(navigator)) === 'object' && navigator && navigator.userAgent || '';
    var platform = (typeof navigator === 'undefined' ? 'undefined' : _typeof(navigator)) === 'object' && navigator && navigator.platform || '';
    var result = '';

    if (userAgent && platform) {
        var isWin = platform.indexOf('Win') === 0;
        var isMac = platform.indexOf('Mac') === 0;
        var isUnix = platform === 'X11' && !isWin && !isMac;
        var isLinux = platform.indexOf("Linux") > -1;
        var isAndroid = userAgent.toLowerCase().match(/android/i) == "android";

        if (isMac) {
            result = 'Mac';
        } else if (isUnix) {
            result = 'Unix';
        } else if (isLinux) {
            if (isAndroid) {
                result = 'Android';
            } else {
                result = 'Linux';
            }
        } else if (isWin) {
            result = 'Windows';
        }
    }

    return result;
};

/**
 * 获取浏览器版本
 * @return {Number} -1表示不是ie，其他就是6/7/8/9/10/11
 */
var getBrowserVersion = exports.getBrowserVersion = function getBrowserVersion() {
    var result = void 0;

    result = parseInt((/msie (\d+)/.exec(userAgent) || [])[1], 10);
    if (isNaN(result)) {
        result = parseInt((/trident\/.*; rv:(\d+)/.exec(userAgent) || [])[1], 10);
    }

    if (isNaN(result)) {
        result = -1;
    }

    return result;
};

/**
 * 是否IE
 */
var isIE = exports.isIE = getBrowserVersion() > 0;

/**
 * 用于键盘可索引性（keyboard accessibility），主要是为了 focus 样式只在键盘索引时生效，而在鼠标操作时不生效，
 */
var initFocusManager = exports.initFocusManager = function initFocusManager() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    // 同一个页面只需要调用一次即可，防止引入多个组件调用多次
    if (!window._had_init_focus_manager) {
        var htmlElement = document.getElementsByTagName('html')[0];

        htmlElement.addEventListener('keydown', function (event) {
            // TAB_KEY_CODE
            if (event.keyCode == 9) {
                var classList = htmlElement.className.split(' ');
                var index = classList.indexOf(className);
                if (index > -1) {
                    classList.splice(index, 1);
                    htmlElement.className = classList.join(' ');
                }
            }
        });

        htmlElement.addEventListener('mousedown', function () {
            var classList = htmlElement.className.split(' ');
            var index = classList.indexOf(className);
            if (index === -1) {
                htmlElement.className = classList.concat(className).join(' ');
            }
        });

        window._had_init_focus_manager = true;
    }
};

exports.default = {
    getBrowserVersion: getBrowserVersion,
    getOSName: getOSName,
    isIE: isIE,
    initFocusManager: initFocusManager
};